import { RootState } from 'src/root/store';

import {
  advancementReportModuleName,
  basicReportsModuleName,
  customReportsModuleName,
  historyReportsModuleName,
  reportsModuleName,
} from './constants';
import { ReportsState } from './types';

export const reportsModuleSel = (state: RootState) => {
  const moduleState = state[reportsModuleName] as ReportsState;

  return moduleState;
};

export const basicReportsModuleSel = (state: RootState) =>
  reportsModuleSel(state)[basicReportsModuleName];
export const historyReportsModuleSel = (state: RootState) =>
  reportsModuleSel(state)[historyReportsModuleName];
export const customReportsModuleSel = (state: RootState) =>
  reportsModuleSel(state)[customReportsModuleName];
export const advancementReportModuleSel = (state: RootState) =>
  reportsModuleSel(state)[advancementReportModuleName];
